import { schema } from "normalizr";
import { ApiModel } from "./model";

interface TranslatableMap {
    en: string; // English is required always
    [key: string]: string;
}

interface Country extends ApiModel {
    name: string;
    code: string;
    printable_name: TranslatableMap;
    name_translations: TranslatableMap;
}

interface Region {
    code: string;
    name: string;
    country_code: string;
}

const NCountry = new schema.Entity("countries", {}, {
    idAttribute: "code",
});

interface LocalisationNormalisedEntities {
    countries?: {
        [key: string]: Country;
    };
}

export {
    Country,
    NCountry,
    Region,
    LocalisationNormalisedEntities,
    TranslatableMap,
};
